<!--  -->
<template>
  <div class="add_box">
    <div class="top">
      <el-row :gutter="10">
        <el-col :span="5">
          <el-input v-model.trim="query.dept_name" placeholder="请输入名称">
            <i slot="prefix" class="el-input__icon el-icon-search" />
          </el-input>
        </el-col>
        <el-button type="primary" @click="menuList">搜索</el-button>
        <el-button
          type="primary"
          @click="resetTencentAdqAdverList"
        >重置</el-button>
      </el-row>
    </div>

    <el-tree
      ref="tree"
      :data="data"
      show-checkbox
      node-key="id"
      :highlight-current="true"
      :default-expand-all="true"
      :expand-on-click-node="false"
      :check-strictly="true"
      :props="defaultProps"
      @check-change="treeCheck"
    />

    <!-- <el-table :data="data" border style="width: 100%">
      <el-table-column align="center" prop="id" label="id" width="200" />
      <el-table-column align="center" prop="dept_code" label="部门编码" />
      <el-table-column align="center" prop="dept_name" label="部门名称" />
      <el-table-column align="center" prop="dept_id" label="部门id" />
      <el-table-column align="center" prop="work_status" label="操作">
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="chooser(scope.row)"
          >选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      :page-sizes="[10]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    /> -->
  </div>
</template>

<script>
// import PaginationRight from '@/components/PaginationRight/index.vue'
import { dept_list } from '@/api/providerAccountManagement/servicePorviderList.js'
export default {
  components: {
    // PaginationRight
  },
  data() {
    return {
      dialogVisible: false,
      total: null,
      adtype: null,
      query: {
        page: 1,
        page_size: 10,
        dept_name: null,
        orgunit_name: null
      },
      data: [],
      defaultProps: {
        children: 'children',
        label: 'dept_name'
      },
      datas: {
        dept_name: '',
        dept_code: ''
      }
    }
  },
  created() {},
  mounted() {
    this.$refs.tree.setCheckedKeys([])
  },
  methods: {
    treeCheck(data, e, r) {
      console.log('data,e,r:', data, e, r)
      // const checkedKeys = this.$refs.tree.getCheckedKeys()
      // console.log('checkedKeys:', checkedKeys, data)
      // this.checkedids = checkedKeys.join(',')
      this.$forceUpdate()
      if (e) {
        this.datas.dept_name = data.dept_name
        this.datas.dept_code = data.dept_code
        console.log('this.data:6666', this.datas)
        this.$emit('bandarr', this.datas)
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys([])
        })
      }
    },
    async menuList() {
      // 获取列表
      const data = await dept_list(this.query)
      console.log('data', data)
      this.data = data.data
      // this.total = data.data.total
    },
    resetTencentAdqAdverList() {
      this.query = {
        page: 1,
        page_size: 10,
        dept_name: null,
        orgunit_name: null
      }
      this.menuList()
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.menuList()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.menuList()
    },
    updatawe() {
      this.dialogVisible = false
      this.menuList()
    },
    async sendr(orgunit_name) {
      await this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys([])
      })
      this.$forceUpdate()
      this.query.orgunit_name = orgunit_name
      console.log(444)
      this.menuList()
    },
    reset() {
      this.objr.page = 1
      this.objr.page_size = 10
      this.objr.keyword = null
      this.objr.status = null
      this.menuList()
    },
    chooser(item) {
      console.log(item)
      this.$emit('bandarr', item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add_box {
  padding: 20px;
}
.defaultrse {
  color: #e6a23c;
}
.defaultr {
  color: #67c23a;
}
.stopew {
  color: red;
}
.fasrw {
  color: #409eff;
}
.sarch_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.sedrtw {
  width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 auto;
}
.sedrtwr {
  width: 380px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 auto;
}
</style>
